import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getTokens, ResponseStatus } from "./spotify";

const SpotifyCallback: React.FC = () => {
    const [ status, setStatus ] = useState<"loading" | "success" | "error">("loading");
    let [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();

    const getSpotifyInfo = async (code: string) => {
        const local = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
        const res = await getTokens(code, local);
        if (res === ResponseStatus.UnknownError || res === ResponseStatus.Unauthorized) {
            setStatus("error");
            return;
        }
        navigate(`/tool?accessToken=${res.accessToken}&refreshToken=${res.refreshToken}&expiresIn=${res.expiresIn}&now=${Date.now()}`);
    }

    useEffect(() => {
        const code = searchParams.get("code");
        const state = searchParams.get("state");

        if (!code || !state) {
            setStatus("error");
            return;
        }

        getSpotifyInfo(code);
    }, [ searchParams ]);

    return (
        <div className="column-centered">
            { 
                status === "loading" && 
                <div className="flex flex-col items-center mt-20">
                    <div className="loading-ellipsis"><div></div><div></div><div></div><div></div></div>
                    <p className="text-center">Loading...</p>
                </div>
            }
        </div>
    );
}

export default SpotifyCallback;
